import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { BulkUserTagsSchema } from '@app/models/users';
import Api from '@app/services/api';

import { USER_TAGS_QUERY_KEY } from '@components/AntFields';

export const useEmployeeTagsQuery = (enabled = true) =>
  useQuery({
    queryKey: USER_TAGS_QUERY_KEY,
    queryFn: () => Api.users.getDictionaryItems('tags'),
    enabled,
  });

// useBulkUserTagsMutation.apply
export const useApplyUserTagQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);
  return useMutation({
    mutationFn: (data: BulkUserTagsSchema) => Api.users.postUserTags(data),
    onSuccess: async () => {
      message.open({ type: 'success', content: commonT.t('dataPatchSuccess') });
      await client.invalidateQueries(['getUsers']);
    },
    onError: () => {
      message.open({ type: 'error', content: commonT.t('error400') });
    },
  });
};

// useBulkUserTagsMutation.remove
export const useRemoveUserTagQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: (data: BulkUserTagsSchema) => Api.users.deleteUserTags(data),
    onSuccess: async () => {
      message.open({ type: 'success', content: commonT.t('dataPatchSuccess') });
      await client.invalidateQueries(['getUsers']);
    },
    onError: () => {
      message.open({ type: 'error', content: commonT.t('error400') });
    },
  });
};
